import {FormEventBus} from '@common/core';
import {ProblemDetailsType, ValidationSettledResult} from '@common/types';

const validateFormAsync = (formsList: string[]) => {
  const responses: Array<{
    task: Promise<void>;
    formId: string;
  }> = [];

  const cb = (task: Promise<void>, formId: string) => {
    responses.push({
      task: task,
      formId: formId,
    });
  };

  for (let formId of formsList) {
    FormEventBus.emit(
      'forms:validate-form',
      {
        formId: formId,
        cb: (task: Promise<void>) => cb(task, formId),
      },
    );
  }

  const promises = responses.map(c => c.task);

  return new Promise<ValidationSettledResult[]>((resolve, reject) => {
    Promise
      .allSettled(promises)
      .then(result => {
        const newResult: Array<ValidationSettledResult> = [];

        for (let i = 0; i < result.length; i++) {
          const response = responses[i];

          const newItem = result[i] as ValidationSettledResult;
          newItem.formId = response.formId;

          newResult.push(newItem);
        }

        resolve(newResult);
      })
      .catch(err => reject(err));
  });
};

export const useForm = (formsIds: string | string[]) => {
  let formsList: string[] = [];
  if (Array.isArray(formsIds)) {
    formsList = formsList.concat(formsIds);
  } else {
    formsList.push(formsIds);
  }

  return {
    cleanErrors: () => {
      for (let formId of formsList) {
        FormEventBus.emit('forms:clean-errors', {formId: formId});
      }
    },

    isValidAsync: async () => {
      const responses = await validateFormAsync(formsList);
      
      return responses.find(c => c.status === 'rejected') === undefined;
    },

    setProblemDetails: (problemDetails: ProblemDetailsType) => {
      for (let formId of formsList) {
        FormEventBus.emit('forms:set-problem-details', {formId: formId, problemDetails: problemDetails});
      }
    },

    validateFormAsync: () => validateFormAsync(formsList),
  };
};